/* Pages */
import ClientBooking from './pages/client-booking'
import Establishment from './pages/establishment'
import Services from './pages/services'
import Professionals from './pages/professionals'
import Time from './pages/time'
import Confirmation from './pages/confirmation'

/* Componentes */
import Footer from './components/shared/footer'
import PageTransition from './hooks/pageTransition';

/* Bibliotecas */
import './App.css';
import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { NavigationProvider } from "./hooks/navigationContext";

function AnimatedRoutes() {

  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/establishment" element={<PageTransition><Establishment /></PageTransition>}></Route>
        <Route path="/clientbooking" element={<PageTransition><ClientBooking /></PageTransition>}></Route>
        <Route path="/services" element={<PageTransition><Services /></PageTransition>}></Route>
        <Route path="/professionals" element={<PageTransition><Professionals /></PageTransition>}></Route>
        <Route path="/time" element={<PageTransition><Time /></PageTransition>}></Route>
        <Route path="/confirmation" element={<PageTransition><Confirmation /></PageTransition>}></Route>
      </Routes>
    </AnimatePresence>
  );
}


function App() {

  useEffect(() => {
    const rootStyles = getComputedStyle(document.documentElement);
    const primaryColor = rootStyles.getPropertyValue('--primary-color').trim();

    const metaTheme = document.querySelector("meta[name=theme-color]");
    if (metaTheme) {
      metaTheme.setAttribute("content", primaryColor);
    }
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <NavigationProvider>
          <AnimatedRoutes />
          <Footer />
        </NavigationProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
